import script from "./OrganizerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizerComponent.vue?vue&type=script&setup=true&lang=js"

import "./OrganizerComponent.vue?vue&type=style&index=0&id=65b30c72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b30c72"]])

export default __exports__